import React from "react";

type props = {
    color: string
    background: string
}
export function Celular1({color="#01C292", background="#F0FFFA" }: props) {
    return(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" fill={background}/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" stroke={color}/>
            <path d="M15.7188 3.125C16.582 3.125 17.3125 3.85547 17.3125 4.71875V18.5312C17.3125 19.4277 16.582 20.125
            15.7188 20.125H8.28125C7.38477 20.125 6.6875 19.4277 6.6875 18.5312V4.71875C6.6875 3.85547 7.38477 3.125
            8.28125 3.125H15.7188ZM12 19.0625C12.5645 19.0625 13.0625 18.5977 13.0625 18C13.0625 17.4355 12.5645 16.9375
            12 16.9375C11.4023 16.9375 10.9375 17.4355 10.9375 18C10.9375 18.5977 11.4023 19.0625 12 19.0625ZM15.7188
            15.4766V5.11719C15.7188 4.91797 15.5195 4.71875 15.3203 4.71875H8.67969C8.44727 4.71875 8.28125 4.91797
            8.28125 5.11719V15.4766C8.28125 15.709 8.44727 15.875 8.67969 15.875H15.3203C15.5195 15.875 15.7188 15.709
            15.7188 15.4766Z" fill={color}/>
            <path d="M10.1765 13V12.06H11.5965V7.88H10.4265V7.16C10.7465 7.1 11.0199 7.03 11.2465 6.95C11.4799 6.86333
            11.6965 6.76 11.8965 6.64H12.7565V12.06H14.0065V13H10.1765Z" fill={color}/>
        </svg>
    )
}